import React from 'react';

import InputGroup from './InputGroup';


class SportField extends React.Component {
  
  constructor(props) {
    super(props);
    this.state = {
      inputVisible : false,
      fieldValues:this.props.fieldValues,
    }
  }

  componentDidUpdate(prevProps, prevState){
      this.state.fieldValues = this.state.fieldValues ? this.state.fieldValues : [];
  }

  componentWillReceiveProps(nextProps){
    this.setState({
      fieldValues : nextProps.fieldValues,
      inputVisible : false,
    })
  }

  onAddClick(){
    this.setState({inputVisible:true});
  }

  onDeleteClick(index){
    this.state.fieldValues.splice(index, 1);
    this.setState({
      fieldValues : this.state.fieldValues,
    });
  }


  onFieldChange(fieldType, value, index, name){

    let fieldValues = this.state.fieldValues;
    let fieldValue = fieldValues[index];

    if (fieldType == 'Levels') {

      fieldValue[this.props.lang][name] = value;

    } else if (fieldType == 'Positions') {

      fieldValue[this.props.lang] = value;

    } else if (fieldType == 'Certificates') {

      fieldValue['name'][this.props.lang] = value; 

    } else {
      console.log('unknown fieldType', fieldType, value, index, name);
    }

    fieldValues[index] = fieldValue;
    this.setState({
      fieldValues: fieldValues
    });

  }

  _getItem(inputGroup){
    let item = {};
    for (let key of Object.keys(inputGroup.refs) ){
      item[key] = inputGroup.refs[key].value;
    }
    return item;
  }

  _getFieldValue(fieldType, item){

    if (fieldType == 'Levels') {

      let fieldValue = {};
      fieldValue[this.props.lang] = item;
      return fieldValue;

    } else if (fieldType == 'Positions') {

      let fieldValue = {};
      fieldValue[this.props.lang] = item.name;
      return fieldValue;

    } else if (fieldType == 'Certificates') {

      let fieldValue = {'name':{}};
      fieldValue['name'][this.props.lang] = item.name;
      return fieldValue;

    } else {
      console.log('unknown fieldType', fieldType, item, index);
      return null;
    }
  }

  onSaveClick(){    
    let item = this._getItem(this.refs.InputGroup);
    let fieldValue = this._getFieldValue(this.props.fieldType, item);

    if(fieldValue){
      this.state.fieldValues.push(fieldValue);
    }

    this.setState({
      fieldValues : this.state.fieldValues,
      inputVisible : false,
    });
  }

  _renderPositionItem(position, index){

    return (
          <tr key={index}>
            <td>
              <input
                type="text"
                onChange={(e)=>this.onFieldChange('Positions', e.target.value, index)}
                className="form-control"
                value={position[this.props.lang] || ''}
              />
            </td>
            <td>
              <button 
                className="btn btn-danger btn-xs" 
                onClick={()=>this.onDeleteClick(index)}>
                  Delete
              </button>
            </td>
          </tr>
      )
  }

  _renderCertificateItem(certificate, index){

    let name = '';
    if(certificate && certificate.name){
      name = certificate.name;
    }
    
    return (
        <tr key={index}>
          <td>
            <input
              type="text"
              onChange={(e)=>this.onFieldChange('Certificates', e.target.value, index)}
              className="form-control"
              value={name[this.props.lang] || ''}
            />
          </td>
          <td>
            <button 
              className="btn btn-danger btn-xs" 
              onClick={()=>this.onDeleteClick(index)}>
                Delete
              </button>
          </td>
        </tr>
      )
  }

  _renderLevelItem(level, index){

    return (
        <tr key={index}>
          <td>
            <input
              type="text"
              onChange={(e)=>this.onFieldChange('Levels', e.target.value, index, 'name')}
              className="form-control"
              value={level[this.props.lang].name}
            />
          </td>
          <td>
            <input
              type="text"
              onChange={(e)=>this.onFieldChange('Levels', e.target.value, index, 'skillLevel')}
              className="form-control"
              value={level[this.props.lang].skillLevel}
            />
          </td>
          <td>
            <input
              type="text"
              onChange={(e)=>this.onFieldChange('Levels', e.target.value, index, 'description')}
              className="form-control"
              value={level[this.props.lang].description}
            />
          </td>
          <td>
            <button 
              className="btn btn-danger btn-xs" 
              onClick={()=>this.onDeleteClick(index)}>
                Delete
              </button>
          </td>
        </tr>
      )
  }

  _renderHeader(headers){
     return (
        <thead>
          <tr>
            {
              headers.map( (header, index, arry) => {
                return <th key={index}>{header}</th>;
              })
            }
          </tr>
        </thead>
      )
  }

  _renderFieldItem(item, index){
    const { fieldType } = this.props;
    if(fieldType == 'Levels'){
      return this._renderLevelItem(item, index);
    }else if(fieldType == 'Positions'){
      return this._renderPositionItem(item, index);
    }else if(fieldType == 'Certificates'){
      return this._renderCertificateItem(item, index);
    }else{
      console.log('unknown fieldType', fieldType, item, index);
    }
  }

  _renderField(fields){
    return (
        <tbody>
          { fields.map( (item, index, arr) => {
              return this._renderFieldItem(item, index);
          })}

          { 
            this.state.inputVisible && 
            <InputGroup
              ref="InputGroup" 
              onSave={this.onSaveClick.bind(this)}
              placeholders={this.props.headerNames}
            />
          }
        </tbody>
      )
  }

  render() {
    let name = this.props.name ? this.props.name : '';
    let headerNames = this.props.headerNames ? this.props.headerNames : [];
    
    return (
        <div style={{display: 'flex',flexDirection:'row', paddingBottom:20}}>
          <label>{name}</label>
          <div style={{paddingLeft:20}}>
            <table className="table table-hover table-condensed table-bordered">
              {this._renderHeader(headerNames)}

              {this._renderField(this.state.fieldValues)}
            </table>
          </div>
          <div style={{paddingLeft:20}}>
           <button className="btn btn-success" onClick={this.onAddClick.bind(this)}>add</button>
          </div>
        </div>
    )
  }

}

SportField.propTypes = ({
  name : React.PropTypes.string.isRequired,
  fieldType : React.PropTypes.string.isRequired,
  headerNames : React.PropTypes.array,
  fieldValues: React.PropTypes.array,
  lang : React.PropTypes.string.isRequired,
});




export default SportField;


// WEBPACK FOOTER //
// ./src/components/SportField.js